<template>
  <div class="header flex items-center relative" :class="headerClass">
    <div class="title"><router-link :to="homeRoute"><img src="./images/logo-horizontal-color-sm.png"></router-link></div>
    <div class="menucontainer-desktop">
      <div class="headercontent">
        <div><router-link :to="homeRoute">Home</router-link></div>
        <div><router-link :to="{ name: 'contact' }">Contact</router-link></div>
        <div><router-link :to="{ name: 'about' }">About</router-link></div>
        <div class="flex-line" v-if="user">
          <router-link :to="{ name: 'profile' }"><img v-if="user.picture" class="avatar" :src="user.picture" /></router-link>
        </div>
        <div v-if="user"><a href="/logout">Log out</a></div>
        <div v-if="!user"><a class="login" :href="externalLoginLink">Log in/Sign Up</a></div>
      </div>
    </div>
    <div class="menucontainer-mobile">
      <nav role="navigation">
        <div id="menuToggle" :class="{ open: showDrawer }" @click="toggleDrawer">
          <div class="hamburger-container">
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </div>
        </div>
      </nav>
    </div>
    <ul id="menu" class="" :class="{ open: showDrawer }">
      <li><router-link :to="homeRoute">Home</router-link></li>
      <li v-if="user">
        <router-link :to="{ name: 'profile' }">Profile <img v-if="user.picture" class="avatar2 inline ml-2 rounded-sm" :src="user.picture" /></router-link>
      </li>
      <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
      <li><router-link :to="{ name: 'about' }">About</router-link></li>
      <li v-if="user"><a href="/logout">Log out</a></li>
      <li v-if="!user"><a class="login" :href="externalLoginLink">Log in</a></li>
    </ul>
  </div>
</template>

<script>
import { getExternalLoginLink } from '../utils/routing'
export default {
  data() {
    return {
      homeRoute: { name: 'home' },
      showDrawer: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    externalLoginLink: () => getExternalLoginLink(),
    headerClass() {
      if (window.location.href.includes('/albums')) {
        return 'hidden land:flex land:items-center'
      }
      return ''
    },
  },
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer
    }
  }
}
</script>

<style lang="stylus">
dark-color = #f2cf63

.avatar2
  max-width 25px

.menucontainer-desktop
  visibility visible

  @media only screen and (max-width: 639px)
    visibility hidden
    display none

.menucontainer-mobile
  visibility hidden
  display none

  @media only screen and (max-width: 639px)
    visibility visible
    display inherit
    position absolute
    top 15px
    right 15px

#menuToggle
  .hamburger-container
    cursor pointer

  span.hamburger-line
    display block
    width 33px
    height 4px
    margin-bottom 7px
    position relative
    background dark-color
    border-radius 3px
    transition transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0), background 0.5s cubic-bezier(0.77,0.2,0.05,1.0), opacity 0.55s ease;

    &:first-child
      transform-origin 0% 0%

    &:last-child
      transform-origin 0% 100%

  &.open
    span.hamburger-line
      &:first-child
        transform rotate(45deg)

      &:nth-child(2)
        opacity 0

      &:last-child
        transform rotate(-45deg)

    ul
      transform none

#menu
  position absolute
  right 0
  top 60px
  width 0
  overflow-x hidden
  white-space nowrap
  background dark-color
  list-style-type none
  -webkit-font-smoothing antialiased
  transition width 0.5s cubic-bezier(0.77,0.2,0.05,1.0)

  &.open
    width 110px

#menu li
  padding 10px 20px
  font-size 18px
  font-weight 400

  &:hover
    background #eba227

#menu li a
  color black

.flex-line
  display flex
  align-items center

.header
  padding 0 30px 0 30px
  background #189ea6
  color white

  .headercontent
    display flex
    flex 1
    justify-content flex-end
    align-items center

    img.avatar
      max-width 50px
      border-radius 10%

    a.login
      color white

    div
      padding-left 20px

      @media only screen and (max-width: 639px)
        padding-left 0
        margin-bottom 20px

        a
          padding-left 20px
  background #054350

  @media only screen and (max-width: 639px)
    flex-direction column
    align-items left

  .title
    flex 1

    @media only screen and (max-width: 639px)
      h1
        margin 15px 0

  a
    color dark-color
    text-decoration none

  a > h1
    color white
</style>
